<app-view #view [code]="'business.detail'" [model]="business" (onEvent)="onEvent($event)"></app-view>